import React, { useState, useEffect } from "react";
import styles from "./CountdownTimer.module.css";

const CountdownTimer = ({ initialTime }) => {
  const storedEndTime = localStorage.getItem("countdownEndTime");
  const now = Math.floor(Date.now() / 1000);
  const endTime = storedEndTime ? parseInt(storedEndTime) : now + initialTime;

  const [timeLeft, setTimeLeft] = useState(endTime - now);

  useEffect(() => {
    if (!storedEndTime) {
      localStorage.setItem("countdownEndTime", endTime);
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime > 0 ? prevTime - 1 : 0;
        if (newTime === 0) {
          localStorage.removeItem("countdownEndTime");
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  const formatTime = (seconds) => {
    const days = Math.floor(seconds / (24 * 60 * 60));
    const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((seconds % (60 * 60)) / 60);
    const secs = seconds % 60;
    return `${days} أيام ${hours} ساعات ${minutes} دقائق ${secs} ثوان`;
  };

  return <div className={styles.countdown}>⏳ العرض سينتهي خلال: {formatTime(timeLeft)}</div>;
};

export default CountdownTimer;
